<!--
 * @Author: gaobin
 * @Date: 2025-06-07 17:26:45
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-08-04 14:02:02
 * @Description: 请填写简介
-->
<script setup>
// import versionChecker from '@utils/versionChecker.js';

const { proxy } = getCurrentInstance();
const store = useStore();
const userInfo = computed(() => store.getters.userInfo);

const subscribeGroup = () => {
  proxy.$services
    .getSubscribeGroupsExt({ method: 'get', bHiddenError: true, judgeTokenExpired: true })
    .then((res) => {
      if (res?.data?.length > 0) {
        // proxy.$goEasy.im.subscribeGroup({
        //   groupIds: res.data,
        //   onSuccess() {
        //     console.log('订阅群消息成功');
        //   },
        //   onFailed(error) {
        //     console.log('订阅群消息失败:', error);
        //   },
        // });
        // 分批订阅群消息，每批50个群ID
        const batchSubscribe = (groupIds, batchSize = 50) => {
          const batches = [];
          // 将群ID数组分割成多个批次
          for (let i = 0; i < groupIds.length; i += batchSize) {
            batches.push(groupIds.slice(i, i + batchSize));
          }

          let currentBatch = 0;
          const totalBatches = batches.length;

          const subscribeBatch = () => {
            if (currentBatch >= totalBatches) {
              console.log('所有群消息订阅完成');
              return;
            }

            const currentGroupIds = batches[currentBatch];
            console.log(
              `正在订阅第 ${currentBatch + 1}/${totalBatches} 批群消息，包含 ${currentGroupIds.length} 个群组`,
            );

            proxy.$goEasy.im.subscribeGroup({
              groupIds: currentGroupIds,
              onSuccess() {
                console.log(`第 ${currentBatch + 1} 批群消息订阅成功`);
                currentBatch++;
                // 继续订阅下一批
                subscribeBatch();
              },
              onFailed(error) {
                console.log(`第 ${currentBatch + 1} 批群消息订阅失败:`, error);
                currentBatch++;
                // 即使失败也继续订阅下一批
                subscribeBatch();
              },
            });
          };

          // 开始分批订阅
          subscribeBatch();
        };

        // 调用分批订阅
        batchSubscribe(res.data);
      }
    });
};

const initIm = async () => {
  console.log('初始化埋点信息');
  // const { userId, userName } = userInfo.value;
  // proxy.$tracker.addUserInfo({
  //   userId,
  //   userName,
  // });
  // 建立goeasy连接
  toConnectGoEasy();
};

// 建立goeasy连接
const toConnectGoEasy = () => {
  if (!proxy || !proxy.$goEasy) {
    console.error('GoEasy 未初始化，请确认已在 main.js 中正确配置');
    return;
  }
  console.log('用户信息', userInfo.value);
  const { userId, firstName } = userInfo.value;
  // 建立连接
  proxy.$goEasy.connect({
    // OTP - 取消注释尝试
    // otp: 'EtXiEVxcm58Z4y0Ucl+Hdg==',
    // 群组id
    id: userId, // im必填，最大长度60字符
    // 用户信息
    data: { avatar: '', nickname: firstName || 'test' }, // 可选，最大长度512字符
    onSuccess(res) {
      // 连接成功
      console.log('GoEasy connect successfully.'); // 连接成功
      subscribeGroup();
    },
    onFailed(error) {
      // 连接失败
      console.log(`Failed to connect GoEasy, code:${error.code},error:${error.content}`, error);
    },
  });
};

const destroyIm = () => {
  proxy.$goEasy.disconnect({
    onSuccess() {
      console.log('GoEasy disconnect successfully.断开连接成功');
    },
    onFailed(error) {
      console.log(`Failed to disconnect GoEasy, code:${error.code},error:${error.content}`);
    },
  });
};

watch(
  userInfo,
  (newVal) => {
    if (newVal?.userId) {
      initIm();
    } else {
      // destroyIm();
    }
  },
  {
    deep: true,
    immediate: true,
  },
);

// 捕获 app error
onError((err) => {
  console.log('错误捕捉', err);
  // 页面显示时检测版本更新
  // versionChecker.checkVersion();
});

onLaunch((options) => {
  console.log('App onLaunch');
  setupPageNotFoundHandler();

  store.dispatch('initSafeArea');

  // 初始化全局信息
  if (options?.query?.utm_source) {
    store.commit('SET_UTM_SOURCE', options?.query?.utm_source);
  }
  // #ifdef APP-PLUS
  // 热更新
  // const timer = setTimeout(() => {
  //   checkAndHandleUpdate();
  //   clearTimeout(timer);
  // }, 3000);
  // uni.onNetworkStatusChange((res) => {
  //   if (res.isConnected && (res.networkType === 'cellular' || res.networkType === 'wifi')) {
  //     // 延迟执行重启应用操作
  //     setTimeout(() => {
  //       // 重启应用以使语言设置生效
  //       // #ifdef H5
  //       location.reload();
  //       // #endif

  //       // #ifdef APP-PLUS
  //       plus.runtime.restart();
  //       // #endif
  //     }, 300);
  //   }
  // });
  // #endif
});

onShow((options) => {
  console.log('App onShow');
  // console.log('options', options);
  // 如果是商品详情页需要存储下id
  if (options?.query?.productId) {
    uni.setStorageSync('PRODUCT_ID', options?.query?.productId);
  }
  // 埋点
  const pages = getCurrentPages();
  // 当前路由
  const curPageRoute = pages[pages.length - 1]?.route || options?.path;
  if (curPageRoute) {
    console.log('初始化进入页面 进行埋点');
    const params = [
      {
        pageUrl: curPageRoute,
        action: 'show',
      },
    ];
    proxy.$eventTracker.addPagePvTracker(params);
  }
});

/**
 * 获取应用widget信息
 */
// const getAppWidgetInfo = () => {
//   return new Promise((resolve) => {
//     plus.runtime.getProperty(plus.runtime.appid, resolve);
//   });
// };

/**
 * 检查并执行应用更新
 */
// const checkAndHandleUpdate = async () => {
//   try {
//     // 获取当前应用信息
//     const widgetInfo = await getAppWidgetInfo();
//     console.log('widgetInfo', widgetInfo);

//     const { version: currentVersion, versionCode: currentVersionCode } = widgetInfo;

//     // 获取服务器最新版本信息
//     const versionRes = await proxy.$services.getNewVersion({ method: 'get', bHiddenError: true });
//     if (versionRes.code !== 200) return;
//     console.log('服务器上的版本', versionRes);
//     // 比较版本是否需要更新
//     if (shouldUpdate(versionRes.data, currentVersion, currentVersionCode)) {
//       await handleUpdate(versionRes.data);
//     }
//   } catch (error) {
//     console.error('更新检查失败:', error);
//   }
// };

/**
 * 判断是否需要更新
 */
// const shouldUpdate = (serverData, currentVersion, currentVersionCode) => {
//   const storedVersion = uni.getStorageSync('APP_VERSION');
//   const storedVersionCode = uni.getStorageSync('APP_VERSION_CODE');
//   console.log('storedVersion', storedVersion);
//   console.log('storedVersionCode', storedVersionCode);

//   // 使用存储的版本号优先比较，没有则使用当前版本
//   const compareVersion = storedVersion || currentVersion;
//   const compareVersionCode = storedVersionCode || currentVersionCode;

//   return serverData.version !== compareVersion || serverData.versionCode !== compareVersionCode;
// };

/**
 * 处理更新流程
 */
// const handleUpdate = async (updateInfo) => {
//   // const downloadRes = await proxy.$services.downLoadWgt({
//   //   method: 'get',
//   //   data: {
//   //     version: updateInfo.version,
//   //     versionCode: updateInfo.versionCode,
//   //     groupName: 'wgt',
//   //   },
//   // });
//   // if (downloadRes.code !== 200 || !downloadRes.data.url) return;
//   // 根据isDownLoad决定更新方式 true 弹窗更新 false 静默更新
//   // !updateInfo.isDownLoad ? await silentUpdate(updateInfo) : showUpdateDialog(updateInfo);
//   // downloadRes.data.isDownLoad
//   //   ? await silentUpdate(downloadRes.data)
//   //   : showUpdateDialog(downloadRes.data);
// };

/**
 * 静默更新
 */
// const silentUpdate = async (downloadData) => {
//   try {
//     const tempFilePath = await downloadFile(downloadData.url);
//     await installWgt(downloadData, tempFilePath);

//     console.log('静默更新完成');
//   } catch (error) {
//     console.error('静默更新失败:', error);
//   }
// };

/**
 * 显示更新弹窗
 */
// const showUpdateDialog = (downloadData) => {
//   console.log('downloadData', downloadData);
//   uni.showModal({
//     title: '版本更新提示',
//     content: '当前有新版本，确定更新吗？',
//     confirmText: '更新',
//     cancelText: '取消',
//     success: async (res) => {
//       if (res.confirm) {
//         try {
//           const tempFilePath = await downloadFile(downloadData.url);
//           console.log('tempFilePath', tempFilePath);
//           await installWgt(downloadData, tempFilePath, true); // 安装后重启
//         } catch (error) {
//           uni.showToast({ title: '更新失败', icon: 'none' });
//         }
//       }
//     },
//   });
// };

/**
 * 下载文件
 */
// const downloadFile = (url) => {
//   return new Promise((resolve, reject) => {
//     const downloadTask = uni.downloadFile({
//       url,
//       success: (res) =>
//         res.statusCode === 200 ? resolve(res.tempFilePath) : reject(new Error('下载失败')),
//       fail: reject,
//     });
//     downloadTask.onProgressUpdate((updateRes) => {
//       // 下载进度
//       console.log('updateRes', updateRes);
//     });
//   });
// };

/**
 * 安装wgt文件
 */
// const installWgt = (downloadData, tempFilePath, shouldRestart = false) => {
//   console.log('installWgt', tempFilePath, shouldRestart);
//   return new Promise((resolve, reject) => {
//     plus.runtime.install(
//       tempFilePath,
//       {
//         force: true,
//       },
//       () => {
//         // 更新本地存储的版本信息
//         uni.setStorageSync('APP_VERSION', downloadData.version);
//         uni.setStorageSync('APP_VERSION_CODE', downloadData.versionCode);
//         shouldRestart && plus.runtime.restart();
//         resolve();
//       },
//       reject,
//     );
//   });
// };

// 监听页面路由是否存在
const setupPageNotFoundHandler = () => {
  uni.onPageNotFound(() => {
    uni.redirectTo({
      url: '/pages/404/index',
    });
  });
};

onHide(() => {
  const pages = getCurrentPages();
  // 当前路由
  const curPageRoute = pages[pages.length - 1]?.route || options?.path;
  console.log('App onHide', curPageRoute);
  if (curPageRoute) {
    console.log('离开页面 去埋点');
    const params = [
      {
        pageUrl: curPageRoute,
        action: 'close',
      },
    ];
    proxy.$eventTracker.addPagePvTracker(params);
  }
});
</script>

<style>
/*每个页面公共css */
</style>
